import { AppConnectionStatuses } from 'integrations-lib/constants/appConnectionStatuses';
import { McpServiceComponent } from './McpServiceComponent';
export const McpReconnectionConfig = {
  serviceComponent: McpServiceComponent,
  statusesForDisplaying: [AppConnectionStatuses.DISCONNECTED]
};